import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {setStore} from "trim-redux";
import TextField from "@material-ui/core/TextField/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {FieldSkeleton} from "../../../../components/Skeletons/FieldSkeleton";
import OpenInBrowserRoundedIcon from '@material-ui/icons/OpenInBrowserRounded';
import LoadingButton from "../../../../components/elements/LoadingButton";
class AddNewVariable extends React.Component {

    state = {
        all_variables:[],
        loading: true,
        new_variable: null,
        SubmitLoading: false,
    };
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/variables/quickViewForChooser/${!!this.props.excludeCategory ? this.props.excludeCategory : ''}`, config)
                .then(response => {
                    this.setState({
                        all_variables:response.data,
                        loading:false
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleAddVariable(value){
        if(value === null){
            this.setState({
                new_variable:''
            })
        }else{
            this.setState({
                new_variable:value
            })
        }
    }
    async handlePushVariable(){
        this.setState({
            SubmitLoading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let data = new FormData();
        data.append('category', this.props.excludeCategory);
        data.append('variable', this.state.new_variable.id);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/categoryVariable/push`,data, config)
                .then(response => {
                    this.setState({
                        new_variable:null,
                        SubmitLoading:false

                    })
                    this.loadData();
                    this.props.reload();

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    classes = this.props.classes;
    render(){
        let {loading,all_variables,new_variable,SubmitLoading} = this.state;
        return (

            <>
                {
                    loading ? <FieldSkeleton small/> :
                        <>
                        <Autocomplete
                            options={all_variables}
                            onChange={(event, value) => this.handleAddVariable(value)}
                            getOptionLabel={option => option.name}
                            value={new_variable}
                            renderInput={params => (
                                <TextField
                                    margin="normal"
                                    {...params}
                                    size="small"
                                    label={Translate.addNewVariable}
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                        />
                            {
                                !!new_variable ?
                                    new_variable  !== null ?
                                    !! new_variable.id ?
                                    <LoadingButton
                                        startIcon={<OpenInBrowserRoundedIcon/>}
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                        loading = {SubmitLoading}
                                        onClick={this.handlePushVariable.bind(this)}
                                    >
                                        {Translate.addNewVariable}
                                    </LoadingButton>
                                    : null : null : null
                            }

                        </>
                }
            </>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(AddNewVariable)));